import { difference, forEach } from 'lodash';
import {
  GET_UNREAD_COUNTER_NOTIFICATIONS_SUCCESS,
  GET_UNREAD_NOTIFICATIONS_SUCCESS,
  GET_UNREAD_NOTIFICATIONS_FAILURE,
  UPDATE_NOTIFICATION_AS_READ_SUCCESS,
  UPDATE_NOTIFICATION_AS_READ_FAILURE,
  UPDATE_ALL_NOTIFICATIONS_AS_READ_SUCCESS,
  UPDATE_ALL_NOTIFICATIONS_AS_READ_FAILURE,
  LOGOUT_COMPLETE,
  GET_ALL_NOTIFICATIONS_ALERT_SUCCESS,
  GET_ALL_NOTIFICATIONS_SOURCE_SUCCESS,
  GET_ALL_NOTIFICATIONS_SUCCESS,
  NEXT_NOTIFICATION_PAGE,
  PREV_NOTIFICATION_PAGE,
  DELETE_RESOURCE_NOTIFICATION_SUCCESS,
} from '../../constants/actionTypes';
import * as notificationsTypes from '../../constants/notificationsTypes';
import { getPaginationMetaFromResponseHeaders } from 'js/reducers/pagination';

const initialState = {
  SOURCE: {
    ids: [],
    byResourceId: {},
    page: 1,
    actualPage: 0,
    totalPages: 0,
    showSize: 3,
  },
  SET: {
    ids: [],
    page: 1,
  },
  ALERT: {
    ids: [],
    byResourceId: {},
    page: 1,
    actualPage: 0,
    totalPages: 0,
    showSize: 3,
  },
  UNREAD: {
    ids: [],
    byResourceId: {},
    page: 1,
  },
  ALL: {
    ids: [],
    byResourceId: {},
    page: 1,
    actualPage: 0,
    totalPages: 0,
    showSize: 3,
  },
  MAIN_ALL: {
    ids: [],
    byResourceId: {},
    page: 1,
    actualPage: 0,
    totalPages: 0,
    showSize: 20,
  },
  unreadCounter: 0,
};

export const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_UNREAD_COUNTER_NOTIFICATIONS_SUCCESS:
      return addUnreadCounter(state, action);

    case GET_UNREAD_NOTIFICATIONS_SUCCESS:
      return addNotificationsToType(state, action, notificationsTypes.UNREAD);

    case GET_UNREAD_NOTIFICATIONS_FAILURE:
      return removeUnreadNotifications(state, action);

    case GET_ALL_NOTIFICATIONS_ALERT_SUCCESS:
      return addNotificationsToType(state, action, notificationsTypes.ALERT);

    case GET_ALL_NOTIFICATIONS_SOURCE_SUCCESS:
      return addNotificationsToType(state, action, notificationsTypes.SOURCE);

    case GET_ALL_NOTIFICATIONS_SUCCESS:
      const { requestInfo = {} } = action;
      const { type } = requestInfo;
      return addNotificationsToType(state, action, type || notificationsTypes.ALL);

    case UPDATE_NOTIFICATION_AS_READ_SUCCESS:
      return updateUnreadNotifications(state, action);

    case UPDATE_ALL_NOTIFICATIONS_AS_READ_SUCCESS:
      return updateUnreadNotifications(state, action);

    case UPDATE_NOTIFICATION_AS_READ_FAILURE:
    case UPDATE_ALL_NOTIFICATIONS_AS_READ_FAILURE:
      //TODO: Should we update the unread ids based on this?
      //NOt for now, because the unread notifications panel needs to be static for now?
      return state;

    case DELETE_RESOURCE_NOTIFICATION_SUCCESS:
      return removeRelatedResources(state, action);

    case PREV_NOTIFICATION_PAGE:
      return prevNotificationPage(state, action, action.payload.type);

    case NEXT_NOTIFICATION_PAGE:
      return nextNotificationPage(state, action, action.payload.type);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return {
        ...state,
      };
  }
};

export default notificationsReducer;

function removeUnreadNotifications(state, action) {
  return {
    ...state,
    UNREAD: {
      ids: [],
      loaded: false,
    },
  };
}

function updateUnreadNotifications(state, action) {
  const { requestInfo } = action;
  let id = requestInfo?.id;
  let readNotifications = !!action.result && Array.isArray(action.result) ? action.result : [id];

  let newUnreadNotifications = difference(state.UNREAD.ids, readNotifications);

  return {
    ...state,
    UNREAD: {
      ...state.UNREAD,
      ids: newUnreadNotifications,
    },
  };
}

function removeRelatedResources(state, action) {
  const {
    type,
    requestInfo: { resourceType, id, resourceId },
  } = action;

  switch (type) {
    case DELETE_RESOURCE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        ALL: {
          ...state.ALL,
          ids: difference(state.ALL.ids, [id]),
          byResourceId: {
            ...state.ALL.byResourceId,
            ...(resourceId
              ? {
                  [resourceId]: difference(state.ALL.byResourceId[resourceId], [id]),
                }
              : {}),
          },
        },
      };
  }
  return state;
}

function addNotificationsToType(state, action, type) {
  const { rspHeaders, requestInfo } = action;
  // TODO: I'm setting a hardcoded limit on pagination to 10.
  // We might need to move it to some other place
  let ids = action.result;
  let totalPages = Math.ceil(ids.length / state[type].showSize);
  let byResourceId = {};

  const meta = getPaginationMetaFromResponseHeaders(rspHeaders, requestInfo);

  forEach(action.result, (id) => {
    let resourceId = action.entities.notifications[id].resource_id;

    if (!byResourceId[resourceId]) {
      byResourceId[resourceId] = [];
    }

    byResourceId[resourceId].push(id);
  });

  return {
    ...state,
    [type]: {
      ...state[type],
      ...meta,
      ids,
      byResourceId,
      page: state[type].page + 1,
      loaded: action.result.length < 10,
      totalPages: meta.numPagesCount,
      lastUpdated: Date.now(),
    },
  };
}

function prevNotificationPage(state, action, type) {
  if (state[type].actualPage <= 0) {
    return state;
  } else {
    return {
      ...state,
      [type]: {
        ...state[type],
        actualPage: state[type].actualPage - 1,
      },
    };
  }
}

function nextNotificationPage(state, action, type) {
  if (state[type].actualPage >= state[type].totalPages - 1) {
    return state;
  } else {
    return {
      ...state,
      [type]: {
        ...state[type],
        actualPage: state[type].actualPage + 1,
      },
    };
  }
}

function addUnreadCounter(state, action) {
  return {
    ...state,
    unreadCounter: action.result[0] || 0,
  };
}
